module.exports = __webpack_public_path__ + "static/skill-factory-img-0b0d4f5c1e2e212c71998ba7d32beb15.svg";